<template>
    <div class="dashboard-wrap">
        <h1 class="dashboard-title">Оплата услуг — {{ servicesList && servicesList[0].category?.title }}</h1>
        <div class="d-block mb-4 pt-2 col-12 col-md-8 col-lg-6 col-xl-6">
            <input type="search" class="form-input search-input" v-model="searchValue" placeholder="Поиск ...">
        </div>
        <div class="dashboard-list">
            <div class="row" v-if="servicesList">
                <template v-for="item in servicesList" :key="item">
                    <router-link :to="'/dashboard/payment-services/' + this.category + '/' + item.id" class="col-12 col-md-4 col-lg-4 col-xl-4 payment-service-wrap" v-if="search(item)">
                        <div class="list-item">
                            <img :src="item.logo ? item.logo : PaymentIcon">
                            <div class="list-item-wrap">
                                <div>
                                    <span class="text-white active">{{ item.name }}</span>
                                </div>
                            </div>
                        </div>
                    </router-link>
                </template>
            </div>
            <div class="row" v-else>
                <span class="icon-text empty">Нет данных</span>
            </div>
        </div>
    </div>
</template>

<script>
import PaymentIcon from '../../assets/img/icons/box.svg'

export default {
    data() {
        return {
            PaymentIcon: PaymentIcon,
            searchValue: '',
            category: ''
        }
    },
    mounted() {
        this.category = this.$router.currentRoute.value.params.category
        this.$store.dispatch('getPaymentServices', this.category)
    },
    computed: {
        servicesList() {
            return this.$store.getters.getPaymentServices
        }
    },
    methods: {
        search(item) {
            return (item.name.toLowerCase().search(this.searchValue.toLowerCase()) !== -1 || item.title.toLowerCase().search(this.searchValue.toLowerCase()) !== -1) ? true : false
        }
    }
}
</script>